import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';
import { mockTestimonials } from '../mock';

export const TestimonialsSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A2540] mb-4">
            O que nossos clientes dizem
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Depoimentos reais de empresas que confiam na VIBE LOG
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockTestimonials.map((testimonial, index) =>
          <Card
            key={testimonial.id}
            className="hover:shadow-2xl transition-all duration-300 border-2 hover:border-[#8B3A9C] relative overflow-hidden"
            style={{ animationDelay: `${index * 100}ms` }}>

              <div className="absolute top-4 right-4 text-[#F4D03F] opacity-20">
                <Quote size={48} />
              </div>
              
              <CardContent className="pt-6 relative z-10">
                <div className="flex items-center mb-4">
                  <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full border-4 border-[#8B3A9C] mr-4" />

                  <div className="flex-1">
                    <h3 className="font-bold text-[#0A2540] text-lg">
                      {testimonial.name}
                    </h3>
                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                    <p className="text-xs text-[#8B3A9C] font-semibold">
                      {testimonial.company}
                    </p>
                  </div>
                </div>

                <div className="flex mb-3">
                  {[...Array(testimonial.rating)].map((_, i) =>
                <Star key={i} size={18} className="fill-[#F4D03F] text-[#F4D03F]" />
                )}
                </div>

                <p className="text-gray-700 leading-relaxed italic">
                  "{testimonial.comment}"
                </p>
              </CardContent>
            </Card>
          )}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-8 bg-white px-8 py-6 rounded-2xl shadow-lg">
            <div className="text-center">
              <p className="text-4xl font-bold text-[#0A2540]">4.9</p>
              <div className="flex justify-center my-1">
                {[...Array(5)].map((_, i) =>
                <Star key={i} size={16} className="fill-[#F4D03F] text-[#F4D03F]" />
                )}
              </div>
              <p className="text-sm text-gray-600">Avaliação média</p>
            </div>
            <div className="h-12 w-px bg-gray-300"></div>
            <div className="text-center">
              <p className="!font-bold !text-4xl text-[#8B3A9C]">100+</p>
              <p className="text-sm text-gray-600">Avaliações</p>
            </div>
            <div className="h-12 w-px bg-gray-300"></div>
            <div className="text-center">
              <p className="text-4xl font-bold text-[#F4D03F]">98%</p>
              <p className="text-sm text-gray-600">Recomendação</p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};